// ABOUTME: Actions panel component for BOL replenishment details
// ABOUTME: Provides dropdown with multiple action options

import { Box, ButtonBase, useTheme } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../theme";
import PopoverModal from "../../../theme/Modal/PopoverModal";
import Shbutton from "../../../theme/buttons/Shbutton";
import Text from "../../../theme/text/Text";
import { LinkOutlined, Schedule, MoreVert } from '@mui/icons-material';

const ActionsPanel = ({ order, onOrderAction, onTimeslotAction, disabled = false }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOrderAction = () => {
        onOrderAction();
        handleClose();
    };

    const handleTimeslotAction = () => {
        onTimeslotAction();
        handleClose();
    };

    if (disabled) {
        return null;
    }

    return (
        <>
            <Shbutton
                className={"group-btn"}
                onClick={handleClick}
                color={"blue"}
                variant="contained"
                endIcon={<MoreVert />}
            >
                {t('actions')}
            </Shbutton>

            <PopoverModal
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <Box
                    sx={{
                        background: theme.palette.mode === "dark" ? colors.grey[100] : "#fff",
                        padding: 1.5,
                        display: "flex",
                        gap: 1,
                        flexDirection: "column",
                        borderRadius: "16px",
                        minWidth: 200,
                    }}
                >
                    <ButtonBase
                        onClick={handleOrderAction}
                        sx={{
                            width: 1,
                            height: 40,
                            borderRadius: "8px",
                            padding: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            paddingX: 1.5,
                            transition: "250ms",
                            "&:hover": {
                                transition: "250ms",
                                background: theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[100],
                            },
                        }}
                    >
                        <Box
                            sx={{
                                width: 32,
                                height: 32,
                                borderRadius: "8px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginRight: 1,
                                color: colors.blue[400],
                            }}
                        >
                            <LinkOutlined fontSize="small" />
                        </Box>
                        <Box>
                            <Text medium>
                                {t('open_order')} {order?.webshopreference}
                            </Text>
                        </Box>
                    </ButtonBase>

                    <ButtonBase
                        onClick={handleTimeslotAction}
                        sx={{
                            width: 1,
                            height: 40,
                            borderRadius: "8px",
                            padding: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            paddingX: 1.5,
                            transition: "250ms",
                            "&:hover": {
                                transition: "250ms",
                                background: theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[100],
                            },
                        }}
                    >
                        <Box
                            sx={{
                                width: 32,
                                height: 32,
                                borderRadius: "8px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginRight: 1,
                                color: colors.green[400],
                            }}
                        >
                            <Schedule fontSize="small" />
                        </Box>
                        <Box>
                            <Text medium>
                                {t('select_timeslot')}
                            </Text>
                        </Box>
                    </ButtonBase>
                </Box>
            </PopoverModal>
        </>
    );
};

export default ActionsPanel;